import { Hero } from "@r8er/components/marketing/hero";
import { Layout } from "@r8er/components/marketing/layout";
import { getCookiePolicy } from "@r8er/lib/cms";
import classes from "@r8er/styles/Policy.module.css";
import type { InferGetStaticPropsType } from "next";
import Head from "next/head";

export async function getStaticProps(context) {
  const cookies = await getCookiePolicy();

  return {
    props: {
      cookies,
    },
  };
}
export default function Terms({
  cookies,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <div>
      <Head>
        <title>{cookies.title}</title>
        <link rel="icon" href="/favicon.png" />
      </Head>

      <Layout>
        <Hero isSlim isTiny title={cookies.title} img="/about-hero.png" />
        <h1 className={classes.title}>{cookies.title}</h1>
        <div
          className={classes.container}
          dangerouslySetInnerHTML={{ __html: cookies.html }}
        ></div>
      </Layout>
    </div>
  );
}
